import { Box, BoxProps, Grid, Stack, Typography } from "@mui/material";
import { memo, useState } from "react";
import { CustomSlider } from "./CustomSlider";

import TextFieldWithButtons from "./TextFieldWithButtons/TextFieldWithButtons";

type OwnProps = {
    label: string;
    max: number;
    min: number;
    initialValue: number;
    onChange: (value: number) => void;
    child?: React.ReactNode;
};

export const SliderWithInput = memo(({ label, max, min, initialValue, onChange, child }: OwnProps) => {
    const [value, setValue] = useState<number>(initialValue);

    const handleSliderChange = (_event: Event, newValue: number | number[]) => {
        typeof newValue === "number" && setValue(newValue);
        typeof newValue === "number" && onChange(newValue);
    };

    const boxStyles: BoxProps["sx"] = {
        display: "flex",
        maxWidth: "105px",
        justifyContent: "space-between",
        alignItems: "center",
    } as const;

    return (
        <Grid container spacing={1} alignItems="center">
            <Grid item width={"150px"}>
                <Grid sx={boxStyles}>
                    <Typography variant="overline" color="text.secondary">
                        {label}
                    </Typography>
                    {child}
                </Grid>
            </Grid>

            <Grid item>
                <TextFieldWithButtons
                    max={max}
                    min={min}
                    isEval={true}
                    hideButtons={true}
                    objValue={value}
                    setObjValue={onChange}
                    style={{ margin: 0 }}
                    inputProps={{
                        style: { width: "95px" },
                    }}
                />
                {/*<TextFieldCustom*/}
                {/*    value={value}*/}
                {/*    size="small"*/}
                {/*    onChange={handleInputChange}*/}
                {/*    onBlur={handleBlur}*/}
                {/*    inputProps={{*/}
                {/*        step: 10,*/}
                {/*        min,*/}
                {/*        max,*/}
                {/*        type: "number",*/}
                {/*        style: {*/}
                {/*            width: "95px",*/}
                {/*        },*/}
                {/*        "aria-labelledby": "input-slider",*/}
                {/*    }}*/}
                {/*/>*/}
            </Grid>
            <Grid item xs>
                <Stack direction={"row"} gap={2}>
                    <Typography
                        variant="overline"
                        color="text.secondary"
                        sx={{ fontFamily: "var(--font-mono)", fontVariantNumeric: "tabular-nums" }}
                    >
                        {min}
                    </Typography>
                    <CustomSlider
                        value={typeof value === "number" ? value : 0}
                        onChange={handleSliderChange}
                        min={min}
                        max={max}
                    />
                    <Typography
                        color="text.secondary"
                        variant="overline"
                        sx={{ fontFamily: "var(--font-mono)", fontVariantNumeric: "tabular-nums" }}
                    >
                        {max}
                    </Typography>
                </Stack>
            </Grid>
        </Grid>
    );
});
